const Testimon = ({ review, rating, name, role, photo }) => {
  let stars = new Array(5).fill(1);
  stars = stars.map((li, index) => {
    if (index <= rating - 1) {
      return (
        <li key={index}>
          <i className="fa fa-star set-color" />
        </li>
      );
    } else {
      return (
        <li key={index}>
          <i className="fa fa-star" />
        </li>
      );
    }
  });
  return (
    <div className="col-lg-12">
      <div className="testi-item">
        <div className="testi-comment">
          <span style={{maxHeight: '400px'}}>
            <p>
              <i className="fa fa-quote-left" />
              {review}
              <i className="fa fa-quote-right" />
            </p>
          </span>
          <ul className="stars list-unstyled">{stars}</ul>
        </div>
        <div className="client-info">
          <img src={photo} alt="no internet connection"></img>
          <h5>{name}</h5>
          <p>{role}</p>
        </div>
      </div>
    </div>
  );
};

export default Testimon;
